import React, { useState } from "react";
import { Box, Button, TextField } from "@mui/material";
import { useMutation } from "react-query";
import { enqueueSnackbar } from "notistack";
import { createAllergyName } from "../../../api/services/allergy";

const AddClientAllergiesModal = ({ onFormAdded, refetch }) => {
  const [formInput, setFormInput] = useState("");

  const postMutation = useMutation(createAllergyName, {
    onSuccess: () => {
      enqueueSnackbar("New allergy added successfully", {
        variant: "success",
      });
      setFormInput("");
      refetch();
      if (onFormAdded) {
        onFormAdded();
      }
    },
    onError: () => {
      enqueueSnackbar("Failed to add allergy", { variant: "error" });
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const allergyData = { name: formInput };
    postMutation.mutate(allergyData);
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        my: 4,
      }}
    >
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 2,
          mt: 2,
          p: 5,
          width: "100%",
        }}
      >
        <TextField
          type="text"
          placeholder="Allergy"
          value={formInput}
          onChange={(e) => setFormInput(e.target.value)}
          required
          size="small"
          sx={{ flexGrow: 1 }}
        />
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={postMutation.isLoading}
          sx={{ minWidth: 120 }}
        >
          Submit
        </Button>
      </Box>
    </Box>
  );
};

export default AddClientAllergiesModal;